
/* styles */
require("!!../../../node_modules/extract-text-webpack-plugin/loader.js?{\"omit\":1,\"extract\":true,\"remove\":true}!vue-style-loader!css-loader?sourceMap!../../../node_modules/vue-loader/lib/style-rewriter?id=data-v-97a7e5c8&scoped=true!../../../node_modules/vue-loader/lib/selector?type=styles&index=0!./QuotationRecord.vue")

var Component = require("!../../../node_modules/vue-loader/lib/component-normalizer")(
  /* script */
  require("!!babel-loader!../../../node_modules/vue-loader/lib/selector?type=script&index=0!./QuotationRecord.vue"),
  /* template */
  require("!!../../../node_modules/vue-loader/lib/template-compiler?id=data-v-97a7e5c8!../../../node_modules/vue-loader/lib/selector?type=template&index=0!./QuotationRecord.vue"),
  /* scopeId */
  "data-v-97a7e5c8",
  /* cssModules */
  null
)

module.exports = Component.exports



//////////////////
// WEBPACK FOOTER
// ./src/pages/orderManagement/QuotationRecord.vue
// module id = 1532
// module chunks = 3